import ReactDOM from 'react-dom';

export const jsxToHtmlElement = (func: JSX.Element): HTMLElement => {
    const popupNode = document.createElement('div');
    ReactDOM.render(func, popupNode);
    return popupNode.children[0] as HTMLElement;
};
